import { useMemo } from 'react';
import { Constants as AccountConstants } from 'we-package-react-account';
import Constants from '~/app/Constants';

interface RequiredRoute {
  path: string;
  required: boolean | string;
  allowed?: boolean;
}

interface UseRequiredRoutesParams {
  isUsernameValidationRequired: boolean | string;
  isSecurityInfoValidationRequired: boolean | string;
  mfaOnboardingStatus: string | undefined;
  isMfaOnboardingLoading: boolean;
  isCentralizationRequired: boolean | string;
  isCentralizationOnboardingLoading: boolean;
  currentPath: string;
}

export default function useRequiredRoutes({
  isUsernameValidationRequired,
  isSecurityInfoValidationRequired,
  mfaOnboardingStatus,
  isMfaOnboardingLoading,
  isCentralizationRequired,
  isCentralizationOnboardingLoading,
  currentPath,
}: UseRequiredRoutesParams) {
  const requiredRoutes: RequiredRoute[] = useMemo(() => ([
    { path: AccountConstants.InvalidUsernameFormPath, required: isUsernameValidationRequired },
    { path: Constants.PagesUrl.SecurityInfoFormPage, required: isSecurityInfoValidationRequired },
    {
      path: AccountConstants.MfaValidationPath,
      required: mfaOnboardingStatus
        ? mfaOnboardingStatus === 'active'
        : localStorage.getItem('we-mfa-onboarding') === 'true',
      allowed: mfaOnboardingStatus === 'completed' || isMfaOnboardingLoading,
    },
    { path: Constants.PagesUrl.CentralizationPage, required: isCentralizationRequired, allowed: isCentralizationOnboardingLoading },
    { path: Constants.PagesUrl.CentralizationPageIaah, required: isCentralizationRequired, allowed: isCentralizationOnboardingLoading },
    { path: Constants.PagesUrl.CentralizationPageIAGP, required: isCentralizationRequired, allowed: isCentralizationOnboardingLoading },
    { path: Constants.PagesUrl.CentralizationPageIAPW, required: isCentralizationRequired, allowed: isCentralizationOnboardingLoading },
    { path: Constants.PagesUrl.CentralizationPageInvestia, required: isCentralizationRequired, allowed: isCentralizationOnboardingLoading },
  ]), [isUsernameValidationRequired, isSecurityInfoValidationRequired, mfaOnboardingStatus, isCentralizationRequired, isMfaOnboardingLoading, isCentralizationOnboardingLoading]);

  const currentRequiredRoute = useMemo(() => (
    requiredRoutes.find(({ path }) => currentPath === path || currentPath.startsWith(`${path}/`))
  ), [currentPath, requiredRoutes]);

  const firstRequiredRoute = useMemo(() => (
    requiredRoutes.find(({ required }) => required)
  ), [requiredRoutes]);

  return { currentRequiredRoute, firstRequiredRoute };
}
